import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  BackofficeContentPane,
  BackofficeHeader,
  BackofficeMobileNavigation,
  BackofficeSidebar,
} from '@/components/layout';
import { BackofficeNavigationPreferenceProvider } from '@/preferences';
import {
  clearBackofficeForbiddenHandler,
  setBackofficeForbiddenHandler,
} from '@/services/backoffice-api';

export function BackofficeHomePage() {
  const [isMobileNavigationOpen, setIsMobileNavigationOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobileNavigationOpen) return undefined;

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setIsMobileNavigationOpen(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMobileNavigationOpen]);

  useEffect(() => {
    setBackofficeForbiddenHandler(() => {
      if (location.pathname !== '/error/403') {
        navigate('/error/403', { replace: true });
      }
    });

    return () => {
      clearBackofficeForbiddenHandler();
    };
  }, [location.pathname, navigate]);

  return (
    <BackofficeNavigationPreferenceProvider>
      <div className="min-h-screen w-full bg-white text-neutral-900">
        <div className="flex min-h-screen w-full flex-col">
          <BackofficeHeader
            isMobileNavigationOpen={isMobileNavigationOpen}
            onOpenMobileNavigation={() => setIsMobileNavigationOpen(true)}
          />
          <BackofficeMobileNavigation
            isOpen={isMobileNavigationOpen}
            onClose={() => setIsMobileNavigationOpen(false)}
          />
          <div className="grid flex-1 border-t border-neutral-200 bg-white lg:grid-cols-[280px_minmax(0,1fr)]">
            <BackofficeSidebar />
            <Outlet />
          </div>
        </div>
      </div>
    </BackofficeNavigationPreferenceProvider>
  );
}

export { BackofficeContentPane };
